import React from "react";

import { Button, CircularProgress, TableCell, TableRow } from "@mui/material";
import clsx from "clsx";

import mainStyles from "../../../../styles";
import { useTrainingMigrationContext } from "./context/training-migration-provider";

export const TriggerTranslationUpgrade: React.FC = () => {
  const classes = mainStyles();
  const { handleStartTranslationsUpgrade, isStartingTranslationUpgrade } =
    useTrainingMigrationContext();

  return (
    <TableRow>
      <TableCell
        className={clsx(
          classes.tableCell,
          classes.leftCell,
          classes.tableLeftColPadding,
        )}
        align="right"
      >
        Start translation upgrade
      </TableCell>
      <TableCell
        className={clsx(
          classes.tableCell,
          classes.leftCell,
          classes.tableRightColPadding,
        )}
        align="left"
        style={{ fontWeight: "normal" }}
      >
        Upgrade the org from linked translations to translations v2. This is not
        reversible. Ask an engineer to enable the feature flag before running.
      </TableCell>
      <TableCell
        className={clsx(classes.tableCell, classes.rightButtonCell)}
        align="center"
      >
        <Button
          className={clsx(classes.spaceTopSmall, classes.spaceRightMedium)}
          variant="contained"
          color="secondary"
          fullWidth
          onClick={handleStartTranslationsUpgrade}
          disabled={isStartingTranslationUpgrade}
          startIcon={
            isStartingTranslationUpgrade ? (
              <CircularProgress size={16} color="inherit" />
            ) : undefined
          }
        >
          {isStartingTranslationUpgrade ? "Starting..." : "Start"}
        </Button>
      </TableCell>
    </TableRow>
  );
};
